import  { useState } from 'react';
import s from './ReviewModal.module.scss';
import ReviewStar from '../../components/ReviewStar/ReviewStar';
import axios from 'axios';
import { FaTimes } from 'react-icons/fa';

const ReviewModal = ({ isOpen, onClose, rezdyId, onReviewSubmitted }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [attribute, setAttribute] = useState('');
  const [name, setName] = useState('');
  const [participationDate, setParticipationDate] = useState('');
  const [rating, setRating] = useState(5);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const reviewData = {
      title,
      body: body,
      attribute: attribute,
      name,
      participation_date: participationDate,
      rating,
      rezdy_id: rezdyId,
    };

    try {
      const response = await axios.post(`${apiUrl}/api/reviews`, reviewData);
      if (response.status === 201) {
        setTitle('');
        setBody('');
        setAttribute('');
        setName('');
        setParticipationDate('');
        setRating(5);
        onReviewSubmitted();
        setShowSuccessMessage(true);
      }
    } catch (error) {
      console.error('Error submitting review:', error);
    }
  };

  const isFormValid =
  title.trim() &&
  body.trim() &&
  attribute &&
  name.trim() &&
  participationDate &&
  rating > 0;

  return (
    <div className={s.modalOverlay} onClick={onClose}>
      <div className={s.modalContent} onClick={(e) => e.stopPropagation()}>
        {showSuccessMessage && (
          <span className={s.successMessage}>口コミを投稿しました。ありがとうございます！🚀</span>
        )}
        <div className={s.titleSection}>
          <h2>レビューを書く</h2>
          <FaTimes className={s.closeButton} onClick={onClose} />
        </div>
        <form onSubmit={handleSubmit}>
          <div className={s.wrapper}>
            <input type="hidden" name="rezdy_id" value={rezdyId} />
            <div className={s.rateAndDate}>
              <div className={`${s.flex} ${s.raw}`}>
                <span className={s.label}>総合評価</span>
                <ReviewStar
                  score={rating}
                  onChange={setRating}
                  required
                />
              </div>
              <div className={s.flex} >
              <span className={s.label}>ツアー参加日<span className={s.required}>＊</span></span>
                <input
                  type="date"
                  name="participation_date"
                  className={s.date}
                  value={participationDate}
                  onChange={(e) => setParticipationDate(e.target.value)}
                  required
                />
                </div>
              </div>
            </div>
            <div className={`${s.flex} ${s.category}`}>
              <span className={s.label}>カテゴリー<span className={s.required}>＊</span></span>
              <select value={attribute} name="attribute" onChange={(e) => setAttribute(e.target.value)} required>
                <option value="">選択してください</option>
                <option value="一人で">一人で</option>
                <option value="カップル・夫婦">カップル・夫婦</option>
                <option value="友達・同僚">友達・同僚</option>
                <option value="家族">家族</option>
                <option value="小さなお子様連れ">小さなお子様連れ</option>
              </select>
            </div>
            <div className={`${s.flex} ${s.name}`}>
              <span className={s.label}>表示名<span className={s.required}>＊</span></span>
              <input
                type="text"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className={`${s.flex} ${s.title}`}>
            <span className={s.label}>タイトル<span className={s.required}>＊</span></span>
            <input
              type="text"
              name="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>
          <div className={`${s.flex} ${s.review}`}>
          <span className={s.label}>口コミ<span className={s.required}>＊</span></span>
            <textarea
              name="body"
              value={body}
              onChange={(e) => setBody(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={!isFormValid}>投稿する</button>
        </form>
      </div>
    </div>
  );
};

export default ReviewModal;
